<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#182444"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#182444" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">
            {{ msg }}
          </span>
        </v-flex>

        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #000">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex xs12 sm9 md10 text-left>
        <span class="mainHeader">Political Party</span>
      </v-flex>
      <!-------------------------ADD CUSTOMER TO SCHEME----------------------------->
      <v-flex xs12 sm3 md2 class="buttons1" pt-2 pt-sm-0 text-right>
        <v-btn dark color="#182444" @click="adddialog = true" class="buttons1">
          <v-icon small>mdi-plus</v-icon> &nbsp; Add New
        </v-btn>
      </v-flex>
       <!-------------------------LIST OF CUSTOMER IN SCHEME----------------------------->
      <v-flex xs12 py-6 text-left>
        <v-card
          class="rounded-lg"
          elevation="0"
          :color="$route.name == 'Dashboard' ? 'transparent' : '#FFFFFF'"
          :flat="$route.name == 'Dashboard' ? true : false"
        >
        <v-layout wrap v-if="partyList">
          <v-flex xs12 px-4 py-3>
                    <v-layout wrap px-2>
                      <v-flex xs1 class="text-left tablefont"><b>S.No.</b></v-flex>
                      <v-flex xs2 class="text-left tablefont"><b>Name</b></v-flex>
                      <v-flex xs2 class="text-left tablefont"><b>Year</b></v-flex>
                      <v-flex xs2 class="text-left tablefont"><b>Founder</b></v-flex>
                      <v-flex xs2 class="text-left tablefont"><b>Leader</b></v-flex>
                      <v-flex xs3 class="text-left tablefont"><b>Action</b></v-flex>
                      
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 px-4>
                <v-divider ></v-divider>
            </v-flex>
                <v-flex xs12 v-if="partyList.length > 0">
                  <v-expansion-panels flat>
                    <v-expansion-panel v-for="(value, i) in partyList" :key="i" >
                      <v-expansion-panel-header
                        v-if="value._id" class="pl-2 pr-4."
                        @click="getinnerData(value._id)"
                      >
                        <v-layout wrap px-4>
                          <v-flex xs1 align-self-center>
                        <span v-if="page == 1">
                          {{ i + 1 }}
                        </span>
                        <span v-else>
                          {{ i + 1 + 20 * (page - 1) }}
                        </span>
                      </v-flex>
                      <v-flex xs2 align-self-center pl-1>
                        <span  v-if="value.name">{{
                          value.name
                        }}</span>
                        <span v-else>-</span>
                      </v-flex>
                      <v-flex xs2 align-self-center pl-1>
                        <span  v-if="value.foundedIn">{{
                          value.foundedIn
                        }}</span>
                        <span v-else>-</span>
                      </v-flex>
                      <v-flex xs2 align-self-center pl-3>
                        <span  v-if="value.founded">{{
                          value.founded
                        }}</span>
                        <span v-else>-</span>
                      </v-flex>
                      <v-flex xs2 align-self-center pl-3>
                        <span  v-if="value.leaderName">{{
                          value.leaderName
                        }}</span>
                        <span v-else>-</span>
                      </v-flex>
                      <v-flex xs3 align-self-center class="text-left" pl-5>
                         <v-layout wrap>
                          <v-flex xs3>
                        <v-icon  color="#182444"  @click="(adddialog2=true),(addId = value._id)">mdi-plus</v-icon>
                          </v-flex>
                          <v-flex xs3>
                              <v-icon
                            size="18"
                            title="View Panchayat"
                            style="cursor: pointer"
                            color="#182444"  @click="$router.push('/addPanchayat?id='+value._id)"
                            >mdi-eye</v-icon
                          >
                            <!-- </v-btn> -->
                       </v-flex>
                          <v-flex xs3>
                            <v-icon
                            size="18"
                            color="#182444"
                            style="cursor: pointer"
                            @click="(deletedialog = true), (DeleteId = value._id)"
                            >mdi-delete</v-icon
                          >
                          </v-flex>
                          <v-flex xs3>
                            <v-icon
                          size="18"
                          color="#182444"
                          style="cursor: pointer"
                          @click="(dialogedit = true), (editItem = value)"
                          >mdi-pencil</v-icon
                        >
                          </v-flex>
                         </v-layout>
                        </v-flex>
                        </v-layout>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-layout wrap>
                          <v-flex xs12 class="button1" px-2>
                            Sub-Party List
                          </v-flex>
                          <v-flex xs12 pa-2>
                            <v-card outlined class="pa-2" color="#f9f9f9">
                              <v-simple-table v-if="SubPartyList" style="background-color:#f9f9f9">
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left tablefont">No.</th>
                                <th class="text-left tablefont">Name</th>
                                <th class="text-left tablefont">Year</th>
                                <th class="text-left tablefont">Founder</th>
                                <th class="text-left tablefont">Leader</th>
                                <th class="text-left tablefont">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(value1, i) in SubPartyList" :key="i">
                                <td>
                                  <span v-if="page == 1">
                                    {{ i + 1 }}
                                  </span>
                                  <span v-else>
                                    {{ i + 1 + 20 * (page - 1) }}
                                  </span>
                                </td>
                                <td>
                                  <span  v-if="value1.name">{{ value1.name }}</span>
                        <span v-else>-</span>
                      </td>
                                <td>
                                  <span v-if="value1.foundedIn">
                                    {{ value1.foundedIn }}
                                  </span>
                                </td>
                                <td><span  v-if="value1.founded">{{ value1.founded }}</span>
                        <span v-else>-</span></td>
                                <td><span  v-if="value1.leaderName">{{ value1.leaderName }}</span>
                        <span v-else>-</span></td>
                                <td>
                                  <v-layout wrap>
                          <v-flex xs6>
                            <v-icon
                            size="18"
                            color="#182444"
                            style="cursor: pointer"
                            @click="(deletedialog2 = true), (DeleteId2 = value1._id)"
                            >mdi-delete</v-icon
                          >
                          </v-flex>
                          <v-flex xs6>
                            <v-icon
                          size="18"
                          color="#182444"
                          style="cursor: pointer"
                          @click="(dialogedit2 = true), (editItem2 = value1)"
                          >mdi-pencil</v-icon
                        >
                          </v-flex>
                         </v-layout>
                                  </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-expansion-panel-content>
                      <v-layout>
            <v-flex xs12 px-4>
                <v-divider ></v-divider>
            </v-flex>
        </v-layout>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-flex>
                <v-flex v-else xs12 align-self-center text-center pa-12 class="tablefont1">
                  No data found
                </v-flex>
              </v-layout>
        </v-card>
        <v-layout wrap v-if="partyList">
          <v-flex xs12 pt-4 v-if="partyList.length > 0">
            <v-pagination
              small
              color="#182444"
              v-model="page"
              :length="Pagelength"
            >
            </v-pagination>
          </v-flex>
        </v-layout>
     
      <!-------------------------PARTY----------------------------->
        <v-dialog width="800px" height="100%" v-model="adddialog">
          <v-form v-model="addcat" ref="addcat" @submit.prevent>
            <v-card tile width="800px" height="100%" class="rounded-lg">
              <v-layout wrap justify-center pa-4>
                <v-flex xs11 text-center><span style="color:#182444;" class="menuhead1">Add Political Party</span></v-flex>
                <v-flex xs1 text-right>
                  <v-icon
                    @click="(adddialog = false)(resetForm())"
                    color="#182444"
                    >mdi-close-box</v-icon
                  ></v-flex
                >
                <v-flex xs8 text-center py-4 >
              <v-divider></v-divider>
            </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm6>
                  <v-layout wrap pb-4>
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Name</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                          :rules="[rules.required]"
                          type="text"
                          v-model="name"
                          outlined
                          dense
                          label="Party Name"
                          color="#50659f"
                          hide-details="auto"
                        ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Founded Year</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            type="number"
                            label="Founded year"
                            v-model="foundedIn"
                            outlined
                            dense
                            color="#50659f"
                            hide-details="auto"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Founder Name</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                          type="text"
                          v-model="founded"
                          outlined
                          dense label="Founder Name"
                          color="#50659f"
                          hide-details="auto"
                        ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Leader Name</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                          type="text"
                          v-model="leaderName"
                          outlined
                          dense label="Leader Name"
                          color="#50659f"
                          hide-details="auto"
                        ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-layout wrap pb-4>
                   
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Description</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea
                          type="text"
                          v-model="description"
                          outlined
                          dense
                          color="#50659f"
                          hide-details="auto"
                        ></v-textarea>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout wrap pb-4 justify-end>
                <v-spacer></v-spacer>
                <v-flex xs3 text-right>
                  <v-layout wrap px-4 justify-end fill-height>
                    <v-flex xs12 text-center align-self-end class="buttons1">
                      <v-btn
                        type="submit"
                        color="#182444"
                        dark
                        block
                        @click="AddMainParty()"
                        ><v-icon>mdi-plus</v-icon>Add</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog width="800px" v-model="dialogedit">
          <v-form v-model="addcat" ref="addcat" @submit.prevent>
            <v-card tile width="800px" class="px-4 py-4 rounded-lg">
              <v-layout wrap justify-center>
                <v-flex xs11 text-center><span style="color:#182444;" class="menuhead1">Edit Party</span></v-flex>
                <v-flex xs1 text-right>
                  <v-icon
                    @click="(dialogedit = false)(resetForm())"
                    color="#182444"
                    >mdi-close-box</v-icon
                  ></v-flex
                >
                <v-flex xs8 text-center py-4 >
              <v-divider></v-divider>
            </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm6>
                  <v-layout wrap pb-4>
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Name</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            :rules="[rules.required]"
                            type="text"
                            label="Enter Party name"
                            v-model="editItem.name"
                            outlined
                            dense
                            color="#50659f"
                            hide-details="auto"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Founded Year</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            :rules="[rules.required]"
                            type="text"
                            label="Enter founded year"
                            v-model="editItem.foundedIn"
                            outlined
                            dense
                            color="#50659f"
                            hide-details="auto"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Founder</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            :rules="[rules.required]"
                            type="text"
                            label="Enter founder name"
                            v-model="editItem.founded"
                            outlined
                            dense
                            color="#50659f"
                            hide-details="auto"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Leader</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            :rules="[rules.required]"
                            type="text"
                            label="Enter leader name"
                            v-model="editItem.leaderName"
                            outlined
                            dense
                            color="#50659f"
                            hide-details="auto"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-layout wrap pb-4>
                   
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Description</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea
                          type="text"
                          v-model="editItem.description"
                          outlined
                          dense
                          color="#50659f"
                          hide-details="auto"
                        ></v-textarea>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout wrap pb-4 justify-end>
                <v-spacer></v-spacer>
                <v-flex xs3 text-right>
                  <v-layout wrap px-4 justify-end fill-height>
                    <v-flex xs12 text-center align-self-end class="buttons1">
                      <v-btn
                        type="submit"
                        color="#182444"
                        dark
                        block
                        @click="editMainParty()"
                        ><v-icon>mdi-pencil</v-icon>Edit</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog width="400px" v-model="deletedialog">
            <v-card width="400px" class="pa-2">
             
              <v-layout wrap justify-center>
                <v-flex xs11 text-center><span style="color:#182444;" class="menuhead1">Delete</span></v-flex>
                <v-flex xs1 text-right>
                  <v-icon
                  @click="deletedialog = false"
                    color="#182444"
                    >mdi-close-box</v-icon
                  ></v-flex
                >
                <v-flex xs8 text-center py-4 >
              <v-divider></v-divider>
            </v-flex>
              </v-layout>
              <v-card-text class="pa-4"
                >Are you sure you want to delete this party?
              </v-card-text>
              <v-card-actions class="pt-3">
                <v-spacer></v-spacer>
                <!-- <v-btn
                  color="grey"
                  text
                  class="button1"
                  @click="deletedialog = false"
                  >Cancel</v-btn
                > -->
                <v-btn
                  color="#182444"
                  class="button1"
                  dark
                  @click="deleteMainParty(DeleteId)"
                  >OK</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
      <!-------------------------SUB-PARTY----------------------------->
      <v-dialog width="800px" height="100%" v-model="adddialog2">
          <v-form v-model="addcat2" ref="addcat" @submit.prevent>
            <v-card tile width="800px" height="100%" class="rounded-lg">
              <v-layout wrap justify-center pa-4>
                <v-flex xs11 text-center><span style="color:#182444;" class="menuhead1">Add Sub-Party</span></v-flex>
                <v-flex xs1 text-right>
                  <v-icon
                    @click="(adddialog2 = false)(resetForm2())"
                    color="#182444"
                    >mdi-close-box</v-icon
                  ></v-flex
                >
                <v-flex xs8 text-center py-4 >
              <v-divider></v-divider>
            </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm6>
                  <v-layout wrap pb-4>
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Name</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                          :rules="[rules.required]"
                          type="text"
                          v-model="subname"
                          outlined
                          dense
                          label="Enter Party Name"
                          color="#50659f"
                          hide-details="auto"
                        ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Founded Year</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            :rules="[rules.required]"
                            type="number"
                            label="Enter founded year"
                            v-model="subfoundedIn"
                            outlined
                            dense
                            color="#50659f"
                            hide-details="auto"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Founder Name</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                          :rules="[rules.required]"
                          type="text"
                          v-model="subfounded"
                          outlined
                          dense label="Founder Name"
                          color="#50659f"
                          hide-details="auto"
                        ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Leader Name</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                          :rules="[rules.required]"
                          type="text"
                          v-model="subleaderName"
                          outlined
                          dense label="Leader Name"
                          color="#50659f"
                          hide-details="auto"
                        ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-layout wrap pb-4>
                   
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Description</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea
                          type="text"
                          v-model="subdescription"
                          outlined
                          dense
                          color="#50659f"
                          hide-details="auto"
                        ></v-textarea>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout wrap pb-4 justify-end>
                <v-spacer></v-spacer>
                <v-flex xs3 text-right>
                  <v-layout wrap px-4 justify-end fill-height>
                    <v-flex xs12 text-center align-self-end class="buttons1">
                      <v-btn
                        type="submit"
                        color="#182444"
                        dark
                        block
                        @click="AddSubParty(addId)"
                        ><v-icon>mdi-plus</v-icon>Add</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog width="800px" v-model="dialogedit2">
          <v-form v-model="addcat" ref="addcat" @submit.prevent>
            <v-card tile width="800px" class="px-4 py-4 rounded-lg">
              <v-layout wrap justify-center>
                <v-flex xs11 text-center><span style="color:#182444;" class="menuhead1">Edit Sub-Party</span></v-flex>
                <v-flex xs1 text-right>
                  <v-icon
                    @click="(dialogedit2 = false)(resetForm())"
                    color="#182444"
                    >mdi-close-box</v-icon
                  ></v-flex
                >
                <v-flex xs8 text-center py-4 >
              <v-divider></v-divider>
            </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 sm6>
                  <v-layout wrap pb-4>
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Name</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            :rules="[rules.required]"
                            type="text"
                            label="Enter Party name"
                            v-model="editItem2.name"
                            outlined
                            dense
                            color="#50659f"
                            hide-details="auto"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Founded Year</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            :rules="[rules.required]"
                            type="text"
                            label="Enter founded year"
                            v-model="editItem2.foundedIn"
                            outlined
                            dense
                            color="#50659f"
                            hide-details="auto"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Founder</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            :rules="[rules.required]"
                            type="text"
                            label="Enter founder name"
                            v-model="editItem2.founded"
                            outlined
                            dense
                            color="#50659f"
                            hide-details="auto"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Leader</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            :rules="[rules.required]"
                            type="text"
                            label="Enter leader name"
                            v-model="editItem2.leaderName"
                            outlined
                            dense
                            color="#50659f"
                            hide-details="auto"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-layout wrap pb-4>
                   
                    <v-flex xs12>
                      <v-layout wrap px-4>
                        <v-flex xs12 text-left>
                          <span class="tablefont">Description</span>
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea
                          type="text"
                          v-model="editItem2.description"
                          outlined
                          dense
                          color="#50659f"
                          hide-details="auto"
                        ></v-textarea>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout wrap pb-4 justify-end>
                <v-spacer></v-spacer>
                <v-flex xs3 text-right>
                  <v-layout wrap px-4 justify-end fill-height>
                    <v-flex xs12 text-center align-self-end class="buttons1">
                      <v-btn
                        type="submit"
                        color="#182444"
                        dark
                        block
                        @click="editSubParty()"
                        ><v-icon>mdi-pencil</v-icon>Edit</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog width="400px" v-model="deletedialog2">
            <v-card width="400px" class="pa-2">
             
              <v-layout wrap justify-center>
                <v-flex xs11 text-center><span style="color:#182444;" class="menuhead1">Delete</span></v-flex>
                <v-flex xs1 text-right>
                  <v-icon
                  @click="deletedialog = false"
                    color="#182444"
                    >mdi-close-box</v-icon
                  ></v-flex
                >
                <v-flex xs8 text-center py-4 >
              <v-divider></v-divider>
            </v-flex>
              </v-layout>
              <v-card-text class="pa-4"
                >Are you sure you want to delete this sub-party?
              </v-card-text>
              <v-card-actions class="pt-3">
                <v-spacer></v-spacer>
                <!-- <v-btn
                  color="grey"
                  text
                  class="button1"
                  @click="deletedialog = false"
                  >Cancel</v-btn
                > -->
                <v-btn
                  color="#182444"
                  class="button1"
                  dark
                  @click="deleteSubParty(DeleteId2)"
                  >OK</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      yearsArray: [],
      showsnackbar: false,
      timeout: 2000,
      deletedialog: false,
      DeleteId: null,
      DeleteId2: null,
      addcat: false,
      editItem: {},
      editItem2: {},
      showSnackBar: false,
      ServerError: false,
      appLoading: false,
      partyList: [],
      SubPartyList:[],
      founded: null,
      name: null,
      foundedIn: null,
      leaderName: "",
      description: "",
      
      subfounded: null,
      subname: null,
      subfoundedIn: null,
      subleaderName: "",
      subdescription: "",
      addId:"",
      page: 1,
      // page: 0,
      currentPage: 1,
      adddialog: false,
      dialogedit: false,
      adddialog2: false,
      dialogedit2: false,
      deletedialog2: false,
      addcat2:false,
      //   curItem: {},
      msg: null,

      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",

        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      curItem: {
        gstSlab2Percentage: 0,
        gstSlab2MinimumPrice: 0,
      },
    };
  },

  watch: {
    currentPage() {
      this.getData();
    },
  },

  mounted() {
    this.getData();
    this.generateYearsArray();
  },

  methods: {
    resetForm() {
      this.$refs.addcat.reset();
    },
    resetForm2() {
      this.$refs.addcat2.reset();
    },
    generateYearsArray() {
      const currentYear = new Date().getFullYear();
      const yearsBack = 5;
      const yearsForward = 20;

      const startYear = currentYear - yearsBack;
      const endYear = currentYear + yearsForward;

      this.yearsArray = Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);
      console.log(this.yearsArray)
    },
    

    AddMainParty() {
      this.appLoading = true;
      axios({
        url: "/main/politicalparty/add",
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          foundedIn: this.foundedIn,
          name: this.name,
          founded: this.founded,
          leaderName: this.leaderName,
          description: this.description,
        },
      })
        .then((response) => {
          this.showSnackBar = true;
          this.adddialog = false;
          this.msg = response.data.msg;
          this.founded = null;
          this.name = null;
          this.foundedIn = null;
          this.leaderName = null;
          this.description = null;
          this.appLoading = false;
      this.$refs.addcat.reset();
          this.getData();
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },

    getData() {
      this.appLoading = true;
      axios({
        url: "/main/politicalparty/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          page: this.page,
          count: 50,
          searchKeyword: "",
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.partyList = response.data.data;
          this.Pagelength = Math.ceil(response.data.count / 50);
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },

    editMainParty() {
      axios({
        url: "/main/politicalparty/edit",
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.editItem._id,
          foundedIn: this.editItem.foundedIn,
          name: this.editItem.name,
          founded: this.editItem.founded,
          leaderName: this.editItem.leaderName,
          description: this.editItem.description,
        },
      })
        .then((response) => {
          this.dialogedit = false;
          this.showSnackBar = true;
          this.msg = response.data.msg;
          this.getData();
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },deleteMainParty(id) {
      axios({
        url: "/main/politicalparty/delete",
        method: "get",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          id: id,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.showSnackBar = true;
            this.deletedialog = false;
            this.msg = response.data.msg;
            this.DeleteId = 0;
            this.appLoading = false;
            this.getData();
          } else {
             this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    AddSubParty(itemid) {
      this.appLoading = true;
      axios({
        url: "/sub/politicalparty/add",
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          foundedIn: this.subfoundedIn,
          name: this.subname,
          founded: this.subfounded,
          leaderName: this.subleaderName,
          description: this.subdescription,
          mainPartyId: itemid,
        },
      })
        .then((response) => {
            if (response.data.status == true) {
          this.showSnackBar = true;
          this.adddialog2 = false;
          this.msg = response.data.msg;
          this.subfounded = null;
          this.subname = null;
          this.subfoundedIn = null;
          this.subleaderName = null;
          this.subdescription = null;
          this.appLoading = false;
      this.$refs.addcat2.reset();
          this.getData();
           } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    editSubParty() {
      axios({
        url: "/sub/politicalparty/edit",
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.editItem2._id,
          foundedIn: this.editItem2.foundedIn,
          name: this.editItem2.name,
          founded: this.editItem2.founded,
          leaderName: this.editItem2.leaderName,
          description: this.editItem2.description,
        },
      })
        .then((response) => {
          this.dialogedit2 = false;
          this.showSnackBar = true;
          this.msg = response.data.msg;
          this.getData();
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    deleteSubParty(id) {
      axios({
        url: "/sub/politicalparty/delete",
        method: "get",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          id: id,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.showSnackBar = true;
            this.deletedialog2 = false;
            this.msg = response.data.msg;
            this.DeleteId2 = 0;
            this.appLoading = false;
            // this.getData();
            location.reload();
          } else {
             this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    getinnerData(id) {
      // this.appLoading = true;
      axios({
        url: "/sub/politicalparty/getlist",
        method: "get",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params:{
          mainPartyId:id,
          // level:"LoksabhaConstituency",
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.SubPartyList = response.data.data;
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
  <style scoped>
.v-text-field input {
  font-family: kumbhBold;
}
</style>
  